module.exports = __webpack_public_path__ + "static/media/rocket-card.6d0f7cbf.svg";